export default __webpack_public_path__ + "static/media/basicTriangle.3ae25552.svg";